(function () {
  var KEY = 'motiro_wishlist';
  var MERGED = 'motiro_wishlist_merged';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6l-1.28-1.17C6.08 15.3 3 12.5 3 9.07 3 6.28 5.2 4.1 8 4.1c1.58 0 3.1.73 4 1.89.9-1.16 2.42-1.89 4-1.89 2.8 0 5 2.18 5 4.97 0 3.43-3.08 6.23-7.72 10.36L12 20.6z"/></svg>';
  var C = null;

  function config() {
    if (C) return C;
    var el = document.getElementById('motiro-wl-config');
    if (!el) return null;
    try { C = JSON.parse(el.textContent); } catch (e) { C = null; }
    return C;
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }

  /* Prisijungusio kliento paskyroje saugomas sarasas, ideda Liquid. */
  function serverList() {
    var c = config();
    if (!c || !c.server || !c.server.length) return [];
    return c.server.map(String);
  }

  /* Sujungiam paskyros ir narsykles sarasus viena karta per sesija. */
  function mergeOnce() {
    var c = config();
    if (!c || !c.loggedIn) return;
    try { if (sessionStorage.getItem(MERGED)) return; } catch (e) {}
    var srv = serverList();
    if (!srv.length) { try { sessionStorage.setItem(MERGED, '1'); } catch (e) {} return; }
    var out = read();
    for (var i = 0; i < srv.length; i++) {
      if (out.indexOf(srv[i]) < 0) out.push(srv[i]);
    }
    write(out);
    try { sessionStorage.setItem(MERGED, '1'); } catch (e) {}
    push();
  }

  /* Issaugom i paskyra. Jei serverio dar nera, tyliai nieko neivyksta. */
  function push() {
    var c = config();
    if (!c || !c.loggedIn || !c.endpoint || !window.fetch) return;
    try {
      fetch(c.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ list: read() }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  /* Ivykis Shopify analitikai. Web Pixel ji paverčia Meta AddToWishlist ivykiu.
     Per Shopify, o ne tiesiai i fbq, kad sutikimu juosta (Consent Mode) veiktu. */
  function track(name, id) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, { productId: String(id) });
      }
    } catch (e) {}
  }

  function mountHeader() {
    var c = config();
    if (!c) return;
    var slots = document.querySelectorAll('header-actions');
    for (var i = 0; i < slots.length; i++) {
      var ha = slots[i];
      if (ha.querySelector('.motiro-wish-link')) continue;
      var a = document.createElement('a');
      a.className = 'header-actions__action motiro-wish-link';
      a.href = c.url;
      a.setAttribute('aria-label', c.label);
      a.setAttribute('title', c.label);
      a.innerHTML = HEART + '<span class="motiro-wish-count" hidden>0</span>';
      ha.insertBefore(a, ha.firstElementChild);
    }
  }

  function paint() {
    mountHeader();
    var list = read();

    var buttons = document.querySelectorAll('.motiro-wish');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = list.indexOf(b.getAttribute('data-wish-id')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? b.getAttribute('data-label-on') : b.getAttribute('data-label-off');
      if (label) { b.setAttribute('aria-label', label); b.setAttribute('title', label); }
    }

    var badges = document.querySelectorAll('.motiro-wish-count');
    for (var j = 0; j < badges.length; j++) {
      badges[j].textContent = list.length;
      badges[j].hidden = list.length === 0;
    }

    var grid = document.getElementById('motiro-wl-grid');
    if (grid) {
      var shown = 0;
      var items = grid.querySelectorAll('[data-wish-item]');
      for (var k = 0; k < items.length; k++) {
        var on2 = list.indexOf(items[k].getAttribute('data-wish-item')) > -1;
        items[k].hidden = !on2;
        if (on2) shown++;
      }
      for (var m = 0; m < list.length; m++) {
        var li = grid.querySelector('[data-wish-item="' + list[m] + '"]');
        if (li) grid.appendChild(li);
      }
      grid.hidden = shown === 0;
      var empty = document.getElementById('motiro-wl-empty');
      if (empty) empty.hidden = shown > 0;
    }
  }

  function toggle(id) {
    id = String(id);
    var a = read(), i = a.indexOf(id);
    var removing = i > -1;
    if (removing) { a.splice(i, 1); } else { a.unshift(id); }
    write(a);
    paint();
    push();
    track(removing ? 'motiro_wishlist_remove' : 'motiro_wishlist_add', id);
  }

  function boot() {
    mergeOnce();
    paint();
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.motiro-wish') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-wish-id'));
  });

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', paint);
  window.addEventListener('pageshow', paint);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
  setTimeout(paint, 600);

  boot();

  window.MotiroWishlist = { read: read, toggle: toggle, paint: paint, push: push };
})();
